import { Spin } from 'antd';
import clsx from 'clsx';
import React from 'react';

const Loading = (props) => {
	const { fullscreen = false } = props;

	const loadingClass = clsx({
		['flex flex-1 items-center justify-center h-full']: true,
		['absolute w-full top-0']: true,
	});
	return (
		<div className={loadingClass}>
			<Spin size="large" fullscreen={fullscreen} />
		</div>
	);
};

export default Loading;
